module.exports = __webpack_public_path__ + "media/images/pricing-cbd418015dc519fb1dfe7c102141aec1.svg";